module.exports = __webpack_public_path__ + "static/media/welcome-photo.ecae74d5.jpg";